<template>
  <div id="cx-attribution">
    <a href="https://www.google.com/maps" class="google-wordmark" target="_blank">Google Maps</a>
    <a href="https://www.google.com/intl/en_us/help/terms_maps/" target="_blank">© Google</a>
    <span v-if="hasCookieConsent"> | </span>
    <a v-if="hasCookieConsent" href="https://leica-geosystems.com/global/privacy-policy" target="_blank" rel="noopener noreferrer">{{ translations.privacyPolicy }}</a>
    <span v-if="hasCookieConsent"> | </span>
    <a v-if="hasCookieConsent && !isChineseDistribution" href="documents/cookie-policy.html" target="_blank" rel="noopener noreferrer">{{ translations.cookiePolicy }}</a>
    <a v-if="hasCookieConsent && isChineseDistribution" href="documents/cookie-policy-china.html" target="_blank" rel="noopener noreferrer">{{ translations.cookiePolicy }}</a>
    <span v-if="hasCookieConsent"> | </span>
    <a v-if="hasCookieConsent" href="https://leica-geosystems.com/global/imprint" target="_blank" rel="noopener noreferrer">{{ translations.imprint }}</a>
    <span v-if="hasCookieConsent && isChineseDistribution"> | </span>
    <a v-if="hasCookieConsent && isChineseDistribution" href="http://www.beian.miit.gov.cn/" target="_blank">京ICP备12051228-3号</a>
  </div>
</template>

<script>
import CxLicenceMixin from '@/mixins/CxLicence.mixin';

export default {
  name: 'CxAttribution',
  mixins: [CxLicenceMixin],
  computed: {
    translations() {
      return {
        privacyPolicy: this.$gettext('Privacy Policy'),
        cookiePolicy: this.$gettext('Cookie Policy'),
        imprint: this.$gettext('Imprint')
      };
    }
  }
};
</script>

<style lang="less" scoped>
@import '../../common';

#cx-attribution {
  position: fixed;
  left: @filterMenuWidth;
  bottom: 0%;
  .flex(row, space-between, center);
  height: 22px;
  z-index: 1;
  overflow: hidden;
  font-size: 12px;
  margin: 0 0 5px 5px;

  a {
    text-decoration: none !important;
    color: @linkColor;
    margin: 0 5px;
  }

  a:hover {
    color: @linkColorHighlight;
  }

  .google-wordmark {
    display: block;
    height: 22px;
    margin: 0 5px;
    z-index: 99999;
    font-weight: 500;
  }
}
</style>